/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Field_RateInputs */

const en_lesson_field_rate = /** @type {(inputs: Lesson_Field_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

const he_lesson_field_rate = /** @type {(inputs: Lesson_Field_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תעריף`)
};

/**
* | output |
* | --- |
* | "Rate" |
*
* @param {Lesson_Field_RateInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_field_rate = /** @type {((inputs?: Lesson_Field_RateInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Field_RateInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_field_rate(inputs)
	return he_lesson_field_rate(inputs)
});